// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_PAGE = {
  page404: '/404',
  license: (force = false) => `/license${force ? '?force=1' : ''}`,
  availableToTransfer: (licenseCode) => `/available-to-transfer?license=${licenseCode}`,
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  analytics: path(ROOTS_DASHBOARD, '/analytics'),
  campaigns: {
    list: path(ROOTS_DASHBOARD, '/campaigns/list'),
    new: path(ROOTS_DASHBOARD, '/campaigns/new'),
    edit: (id) => path(ROOTS_DASHBOARD, `/campaigns/edit/${id}`),
    overview: (id) => path(ROOTS_DASHBOARD, `/campaigns/overview/${id}`),
  },
  notifications: path(ROOTS_DASHBOARD, '/notifications'),
  reports: path(ROOTS_DASHBOARD, '/reports'),
  serp: path(ROOTS_DASHBOARD, '/serp'),
  settings: path(ROOTS_DASHBOARD, '/settings'),
  threads: path(ROOTS_DASHBOARD, '/threads'),
  about: path(ROOTS_DASHBOARD, '/about'),
  help: path(ROOTS_DASHBOARD, '/help'),
  logout: path(ROOTS_DASHBOARD, '/logout'),
};
